/**
 * ApplyWarningsPanel — amber, non-blocking list of project-level apply warnings
 * (plan-finish-past-end, dropped edges, rounding drift, scope-qty kept). Never
 * disables the Apply button — blocks own that.
 * Visual register: Sovereign Emerald.
 */
import { TriangleAlert } from 'lucide-react';
import { SOVEREIGN } from '../../../utils/epcProjectVisual';

export interface ApplyWarningsPanelProps {
    warnings: string[];
}

export function ApplyWarningsPanel({ warnings }: ApplyWarningsPanelProps) {
    if (warnings.length === 0) return null;
    return (
        <div
            className="rounded-2xl p-4"
            style={{
                background: 'rgba(201,169,97,0.08)',
                border: '1px solid rgba(201,169,97,0.45)',
            }}
        >
            <div
                className="mb-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.12em]"
                style={{ color: '#8A5A08' }}
            >
                <TriangleAlert size={12} aria-hidden />
                {warnings.length} {warnings.length === 1 ? 'warning' : 'warnings'}
            </div>
            <ul className="m-0 list-none space-y-1 p-0">
                {warnings.map((w) => (
                    <li
                        key={w}
                        className="flex items-start gap-1.5 text-[12px] font-semibold"
                        style={{ color: '#8A5A08' }}
                    >
                        <TriangleAlert size={11} className="mt-0.5 shrink-0" aria-hidden />
                        {w}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ApplyWarningsPanel;
